import React, { useState, } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Grid,
  LinearProgress,
  Typography
} from '@material-ui/core';
import { ToggleButtonGroup, ToggleButton } from '@material-ui/lab';
import ViewModuleIcon from '@material-ui/icons/ViewModule';

import { Paginate } from 'components';
import { ParkingCard } from 'components';

const useStyles = makeStyles(theme => ({
  root: {},
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    marginBottom: theme.spacing(2)
  },
  title: {
    position: 'relative',
    '&:after': {
      position: 'absolute',
      bottom: -8,
      left: 0,
      content: '" "',
      height: 3,
      width: 48,
      backgroundColor: theme.palette.primary.main
    }
  },
  actions: {
    display: 'flex',
    alignItems: 'center'
  },
  sortButton: {
    textTransform: 'none',
    letterSpacing: 0,
    marginRight: theme.spacing(2)
  },
  paginate: {
    marginTop: theme.spacing(3),
    display: 'flex',
    justifyContent: 'center'
  }
}));

const rowsPerPage = 10

const Projects = props => {
  const { parkings, isLoading, className, ...rest } = props;

  const classes = useStyles();
  const [currentPage, setCurrentPage] = useState(0)
  const [mode, setMode] = useState('');

  const handleModeChange = (event, value) => {
    setMode(value);
  };

  const handleSetCurrentPage = (page) => {
    setCurrentPage(page.selected)
  }

  return parkings ? (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <div className={classes.header}>
        <Typography
          className={classes.title}
          variant="h5"
        >
          Showing {parkings.length} parkings
        </Typography>
        <div className={classes.actions}>
          <ToggleButtonGroup
            exclusive
            onChange={handleModeChange}
            size="small"
            value={mode}
          >
            <ToggleButton value="grid">
              <ViewModuleIcon />
            </ToggleButton>
          </ToggleButtonGroup>
        </div>
      </div>
      {isLoading && <LinearProgress />}
      <Grid
        container
        spacing={3}
      >
        {parkings.slice(currentPage * rowsPerPage, (currentPage * rowsPerPage) + rowsPerPage).map((parking, index) => (
          <Grid
            item
            key={parking.id}
            md={mode === 'grid' ? 4 : 12}
            sm={mode === 'grid' ? 6 : 12}
            xs={12}
          >
            <ParkingCard parking={parking} />
          </Grid>
        ))}
      </Grid>
      <div className={classes.paginate}>
        <Paginate pageCount={Math.ceil(parkings.length / 10)} pageRangeDisplayed={currentPage} onPageChange={handleSetCurrentPage}/>
      </div>
    </div>
  ) : null
};

Projects.propTypes = {
  parkings: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
  className: PropTypes.string
};

export default Projects;
